import forEach from '../../../../javascripts/dom/forEach';

const contactQuoteTeaser = document.querySelectorAll("[data-js-module='o-contact-quote-teaser']");
const openClass = 'm-contact-quote-teaser--hover';
const imageOpenClass = 'm-contact-quote-teaser__image-wrapper--hover';

if (contactQuoteTeaser) {
  forEach(contactQuoteTeaser, (index, element) => {
    const quoteLinks = element.querySelectorAll('.m-contact-quote-teaser__quote-inner');
    const imageLinks = element.querySelectorAll('.m-contact-quote-teaser__image-wrapper-withhover');

    forEach(quoteLinks, (indexLink, link) => {
      if ('ontouchstart' in window || (window.DocumentTouch && document instanceof DocumentTouch)) {
        link.addEventListener('click', event => {
          event.preventDefault();
          const quoteText = element.querySelector('.m-contact-quote-teaser__quote-text p');
          const textHeight = quoteText.clientHeight;
          const quoteMarkBorder = element.querySelector(
            '.m-contact-quote-teaser__quote-mark-border'
          );
          element.classList.toggle(openClass);
          if (quoteMarkBorder.style.top === '') {
            quoteMarkBorder.style.top = `${textHeight + 12}px`;
            quoteMarkBorder.style.marginTop = '0px';
          } else {
            quoteMarkBorder.style.top = null;
            quoteMarkBorder.style.marginTop = null;
          }
        });
      } else {
        link.addEventListener('mouseover', event => {
          event.preventDefault();
          const quoteText = element.querySelector('.m-contact-quote-teaser__quote-text p');
          const textHeight = quoteText.clientHeight;
          const quoteMarkBorder = element.querySelector(
            '.m-contact-quote-teaser__quote-mark-border'
          );
          element.classList.toggle(openClass);
          quoteMarkBorder.style.top = `${textHeight + 12}px`;
          quoteMarkBorder.style.marginTop = '0px';
        });

        link.addEventListener('mouseout', event => {
          event.preventDefault();
          const quoteMarkBorder = element.querySelector(
            '.m-contact-quote-teaser__quote-mark-border'
          );
          element.classList.toggle(openClass);
          quoteMarkBorder.style.top = null;
          quoteMarkBorder.style.marginTop = null;
        });
      }
    });

    forEach(imageLinks, (imageLink, imagelink) => {
      if ('ontouchstart' in window || (window.DocumentTouch && document instanceof DocumentTouch)) {
        imagelink.addEventListener('click', event => {
          event.preventDefault();
          imagelink.classList.toggle(imageOpenClass);
        });
      } else {
        imagelink.addEventListener('mouseover', event => {
          event.preventDefault();
          imagelink.classList.toggle(imageOpenClass);
        });

        imagelink.addEventListener('mouseout', event => {
          event.preventDefault();
          imagelink.classList.toggle(imageOpenClass);
        });
      }
    });
  });
}
